
            //------------------------------------------------------------------------------
            // <auto-generated>
            //     This code was generated from a template.
            //
            //     Manual changes to this file may cause unexpected behavior in your application.
            //     Manual changes to this file will be overwritten if the code is regenerated.
            // </auto-generated>
            //------------------------------------------------------------------------------
        
	export enum Localization {
		 Accept = 'accept',
		 AcceptingJob = 'acceptingJob',
		 AcceptingJobDateDescription = 'acceptingJobDateDescription',
		 AcceptingJobTimeDescription = 'acceptingJobTimeDescription',
		 AcceptSelected = 'acceptSelected',
		 AcceptTheCrop = 'acceptTheCrop',
		 Account = 'account',
		 AccountAlreadyConfirmed = 'accountAlreadyConfirmed',
		 AccountConfirmation = 'accountConfirmation',
		 AccountConfirmationFailed = 'accountConfirmationFailed',
		 AccountInvitation = 'accountInvitation',
		 AccountNotConfirmed = 'accountNotConfirmed',
		 Action = 'action',
		 ActionLogAssigned = 'actionLogAssigned',
		 ActionLogCreated = 'actionLogCreated',
		 ActionLogStatusChanged = 'actionLogStatusChanged',
		 ActionLogUnassigned = 'actionLogUnassigned',
		 ActionLogUpdated = 'actionLogUpdated',
		 ActionRecord = 'actionRecord',
		 Actions = 'actions',
		 ActionStatus = 'actionStatus',
		 Activate = 'activate',
		 Active = 'active',
		 ActiveFiltersLabel = 'activeFiltersLabel',
		 AddBuilding = 'addBuilding',
		 AddContact = 'addContact',
		 AddIssue = 'addIssue',
		 AddJob = 'addJob',
		 AddLog = 'addLog',
		 AddNewContact = 'addNewContact',
		 AddUserFeeInfo = 'addUserFeeInfo',
		 All = 'all',
		 AllBuildings = 'allBuildings',
		 AllUpcoming = 'allUpcoming',
		 App = 'app',
		 Application = 'application',
		 ApplicationName = 'applicationName',
		 April = 'april',
		 AreYouSureYouWantToDeleteBuildingFromThisInterventionTeam = 'areYouSureYouWantToDeleteBuildingFromThisInterventionTeam',
		 AreYouSureYouWantToDeleteContactFromThisInterventionTeam = 'areYouSureYouWantToDeleteContactFromThisInterventionTeam',
		 AreYouSureYouWantToDeleteContactTo = 'areYouSureYouWantToDeleteContactTo',
		 AreYouSureYouWantToDeleteInterventionTeam = 'areYouSureYouWantToDeleteInterventionTeam',
		 AreYouSureYouWantToDeleteThisPhoto = 'areYouSureYouWantToDeleteThisPhoto',
		 Ascending = 'ascending',
		 Assign = 'assign',
		 AssignBoard = 'assignBoard',
		 AssignedTo = 'assignedTo',
		 AssignJob = 'assignJob',
		 AssignJobs = 'assignJobs',
		 August = 'august',
		 AutoAccept = 'autoAccept',
		 AutoAcceptInformation = 'autoAcceptInformation',
		 Back = 'back',
		 BackToJobs = 'backToJobs',
		 BadPasswordLength = 'badPasswordLength',
		 Basic = 'basic',
		 BeforeEndOfDay = 'beforeEndOfDay',
		 Building = 'building',
		 BuildingManager = 'buildingManager',
		 BuildingName = 'buildingName',
		 Buildings = 'buildings',
		 By = 'by',
		 ByBuilding = 'byBuilding',
		 ByInterventionTeam = 'byInterventionTeam',
		 Cancel = 'cancel',
		 CancelJob = 'cancelJob',
		 CannotDeleteInterventionTeamMessage = 'cannotDeleteInterventionTeamMessage',
		 CannotMoveActionWithThisStatus = 'cannotMoveActionWithThisStatus',
		 Category = 'category',
		 ChangeJobStatusTo = 'changeJobStatusTo',
		 ChangeStatus = 'changeStatus',
		 ChappsAccount = 'chappsAccount',
		 City = 'city',
		 Close = 'close',
		 Comment = 'comment',
		 Company = 'company',
		 Completed = 'completed',
		 CompletedJobs = 'completedJobs',
		 ConfirmAccount = 'confirmAccount',
		 ConfirmDeleteVideo = 'confirmDeleteVideo',
		 ConfirmLoginForChappsMaintenance = 'confirmLoginForChappsMaintenance',
		 ConfirmPassword = 'confirmPassword',
		 ConfirmPasswordDoesNotMatchThePassword = 'confirmPasswordDoesNotMatchThePassword',
		 Contact = 'contact',
		 Contacts = 'contacts',
		 Continue = 'continue',
		 Country = 'country',
		 CreatedBy = 'createdBy',
		 CreatedOn = 'createdOn',
		 CreateNewInterventionTeam = 'createNewInterventionTeam',
		 CropAllImagesAutomatically = 'cropAllImagesAutomatically',
		 CropImagesBeforeUpload = 'cropImagesBeforeUpload',
		 Dashboard = 'dashboard',
		 DateOfBirth = 'dateOfBirth',
		 Day = 'day',
		 Deactivate = 'deactivate',
		 December = 'december',
		 Decline = 'decline',
		 DeclineJobsCount = 'declineJobsCount',
		 DefaultInterventionTeam_Cleaning = 'defaultInterventionTeam_Cleaning',
		 DefaultInterventionTeam_Janitor = 'defaultInterventionTeam_Janitor',
		 DefaultInterventionTeam_Painting = 'defaultInterventionTeam_Painting',
		 DefaultInterventionTeam_Plumber = 'defaultInterventionTeam_Plumber',
		 DefaultJobs = 'defaultJobs',
		 Delete = 'delete',
		 DeleteContactMessage = 'deleteContactMessage',
		 DeleteJob = 'deleteJob',
		 DeleteJobs = 'deleteJobs',
		 DeletePhotoErrorMessage = 'deletePhotoErrorMessage',
		 Descending = 'descending',
		 Description = 'description',
		 Details = 'details',
		 Discard = 'discard',
		 DueDate = 'dueDate',
		 Edit = 'edit',
		 EditDetails = 'editDetails',
		 EditInfo = 'editInfo',
		 Element = 'element',
		 Email = 'email',
		 EmailAddressAlreadyConfirmed = 'emailAddressAlreadyConfirmed',
		 EmailHasBeenSendTo = 'emailHasBeenSendTo',
		 EmptyDataMessage = 'emptyDataMessage',
		 ErrorHeader = 'errorHeader',
		 ErrorMessage = 'errorMessage',
		 ErrorSubheader = 'errorSubheader',
		 Execute = 'execute',
		 ExecutedAfter = 'executedAfter',
		 ExecutedBefore = 'executedBefore',
		 Executor = 'executor',
		 ExitConfirmation = 'exitConfirmation',
		 Ext = 'ext',
		 February = 'february',
		 Feedback = 'feedback',
		 FileOverSizeLimit = 'fileOverSizeLimit',
		 Filter = 'filter',
		 Filters = 'filters',
		 Finish = 'finish',
		 Finished = 'finished',
		 FinishJob = 'finishJob',
		 FinishJobExplanation = 'finishJobExplanation',
		 FinishJobs = 'finishJobs',
		 FinishJobsExplanation = 'finishJobsExplanation',
		 FirstName = 'firstName',
		 FirstThingMorning = 'firstThingMorning',
		 ForbiddenHeader_Interventions = 'forbiddenHeader_Interventions',
		 ForbiddenMessage_Interventions = 'forbiddenMessage_Interventions',
		 ForgotPassword = 'forgotPassword',
		 From = 'from',
		 Gender = 'gender',
		 GenerateWorkOrderReference = 'generateWorkOrderReference',
		 GetJobDetailsErrorMessage = 'getJobDetailsErrorMessage',
		 GetJobIssuesErrorMessage = 'getJobIssuesErrorMessage',
		 GetJobListErrorMessage = 'getJobListErrorMessage',
		 GetJobLogErrorMessage = 'getJobLogErrorMessage',
		 GetJobMediaErrorMessage = 'getJobMediaErrorMessage',
		 GetStarted = 'getStarted',
		 GoToIssue = 'goToIssue',
		 GoToLoginPage = 'goToLoginPage',
		 Help = 'help',
		 Helpdesk = 'helpdesk',
		 HideImages = 'hideImages',
		 Home = 'home',
		 Hour = 'hour',
		 HouseNumber = 'houseNumber',
		 IdCardNumber = 'idCardNumber',
		 IHaveReadAndAgreeToTheLicenseAgreementAbove = 'iHaveReadAndAgreeToTheLicenseAgreementAbove',
		 Image = 'image',
		 Inactive = 'inactive',
		 InAM = 'inAM',
		 IncorrectConfirmationCode = 'incorrectConfirmationCode',
		 InPM = 'inPM',
		 Inspection = 'inspection',
		 Instructions = 'instructions',
		 Interventions = 'interventions',
		 InterventionTeam = 'interventionTeam',
		 InterventionTeams = 'interventionTeams',
		 InvalidEmail = 'invalidEmail',
		 Invite = 'invite',
		 InvoiceNumber = 'invoiceNumber',
		 Issue = 'issue',
		 IssueLocationInfo = 'issueLocationInfo',
		 IssueLog = 'issueLog',
		 IssueNotificationStatus = 'issueNotificationStatus',
		 IssueObserverInfo = 'issueObserverInfo',
		 Issues = 'issues',
		 IssueSavedAndSend = 'issueSavedAndSend',
		 IssueStatus = 'issueStatus',
		 January = 'january',
		 Job = 'job',
		 JobAssigned = 'jobAssigned',
		 JobAssignedMessage = 'jobAssignedMessage',
		 JobAssignedToTeam = 'jobAssignedToTeam',
		 JobCancelledMessage = 'jobCancelledMessage',
		 JobFinishedMessage = 'jobFinishedMessage',
		 JobFor = 'jobFor',
		 JobLog = 'jobLog',
		 Jobs = 'jobs',
		 JobsApp = 'jobsApp',
		 JobsAssignedMessage = 'jobsAssignedMessage',
		 JobsCancelledMessage = 'jobsCancelledMessage',
		 JobScheduledOn = 'jobScheduledOn',
		 JobsFinishedMessage = 'jobsFinishedMessage',
		 JobsList = 'jobsList',
		 JobsResolved = 'jobsResolved',
		 JobStatus = 'jobStatus',
		 JobType = 'jobType',
		 July = 'july',
		 June = 'june',
		 KindOfProblem = 'kindOfProblem',
		 Label = 'label',
		 Language = 'language',
		 LastLogin = 'lastLogin',
		 LastModifiedBy = 'lastModifiedBy',
		 LastName = 'lastName',
		 LastSync = 'lastSync',
		 LatestIssues = 'latestIssues',
		 LatestJobs = 'latestJobs',
		 Level = 'level',
		 LicenseAgreement = 'licenseAgreement',
		 LicenseNotAgreed = 'licenseNotAgreed',
		 LinkedJobs = 'linkedJobs',
		 LinkedToAllBuildings = 'linkedToAllBuildings',
		 List = 'list',
		 Location = 'location',
		 Log = 'log',
		 Login = 'login',
		 LoginAlreadyConfirmed = 'loginAlreadyConfirmed',
		 LoginInTheChappsMaintenanceOrganizer = 'loginInTheChappsMaintenanceOrganizer',
		 Logins = 'logins',
		 Logout = 'logout',
		 LoseUnsavedChanges = 'loseUnsavedChanges',
		 Mailbox = 'mailbox',
		 March = 'march',
		 MaximumUploadFileSize = 'maximumUploadFileSize',
		 May = 'may',
		 Media = 'media',
		 Message = 'message',
		 Minute = 'minute',
		 Month = 'month',
		 Months = 'months',
		 MyAccount = 'myAccount',
		 NationalRegistrationNumber = 'nationalRegistrationNumber',
		 NavigateToOriginalIssue = 'navigateToOriginalIssue',
		 New = 'new',
		 NewestFirst = 'newestFirst',
		 NewUserCreatedMailSubject = 'newUserCreatedMailSubject',
		 Next = 'next',
		 NextWeek = 'nextWeek',
		 No = 'no',
		 NoActionsSpecified = 'noActionsSpecified',
		 NoDate = 'noDate',
		 NoInterventionTeamJobs = 'noInterventionTeamJobs',
		 NoJobsMessage = 'noJobsMessage',
		 NotConfirmed = 'notConfirmed',
		 NoTime = 'noTime',
		 NotUrgent = 'notUrgent',
		 November = 'november',
		 NumberOfActiveJobs = 'numberOfActiveJobs',
		 Observation = 'observation',
		 ObservedOn = 'observedOn',
		 ObservedOnDate = 'observedOnDate',
		 Observer = 'observer',
		 October = 'october',
		 Offline = 'offline',
		 OfflineMessage = 'offlineMessage',
		 OK = 'oK',
		 OldestFirst = 'oldestFirst',
		 On = 'on',
		 OpenJobs = 'openJobs',
		 Or = 'or',
		 OrDownloadMobileApp = 'orDownloadMobileApp',
		 OtherDate = 'otherDate',
		 Password = 'password',
		 PasswordMustBeAtLeast = 'passwordMustBeAtLeast',
		 PasswordsDoNotMatch = 'passwordsDoNotMatch',
		 PasswordSetError = 'passwordSetError',
		 PasswordSetSuccess = 'passwordSetSuccess',
		 PeriodShownForFinishedJobs = 'periodShownForFinishedJobs',
		 Phone = 'phone',
		 PhoneNumber = 'phoneNumber',
		 Photos = 'photos',
		 PleaseContactWithAdministrator = 'pleaseContactWithAdministrator',
		 Priority = 'priority',
		 Proceed = 'proceed',
		 Processing = 'processing',
		 Record = 'record',
		 RecordVideoHeader = 'recordVideoHeader',
		 Reference = 'reference',
		 RejectSelected = 'rejectSelected',
		 Reload = 'reload',
		 RemoveJob = 'removeJob',
		 Reopen = 'reopen',
		 Requested = 'requested',
		 RequestErrorMessage = 'requestErrorMessage',
		 Required = 'required',
		 RequiredByTheEndOf = 'requiredByTheEndOf',
		 ResendInvitationMail = 'resendInvitationMail',
		 Reset = 'reset',
		 ResetPassword = 'resetPassword',
		 ResetPasswordSuccess = 'resetPasswordSuccess',
		 Resolved = 'resolved',
		 ResolveIssue = 'resolveIssue',
		 ReturnToChappsMaintenanceOrganizer = 'returnToChappsMaintenanceOrganizer',
		 Save = 'save',
		 SaveAndSendTo = 'saveAndSendTo',
		 Scheduled = 'scheduled',
		 SeeMore = 'seeMore',
		 SelectBuilding = 'selectBuilding',
		 SelectContact = 'selectContact',
		 SelectedImage = 'selectedImage',
		 SelectInterventionTeam = 'selectInterventionTeam',
		 Send = 'send',
		 SendAgain = 'sendAgain',
		 SendAllJobsDescription = 'sendAllJobsDescription',
		 SendTo = 'sendTo',
		 Sent = 'sent',
		 September = 'september',
		 SetCultureConfirmationMessage = 'setCultureConfirmationMessage',
		 SetPasswordMessage = 'setPasswordMessage',
		 SetPasswordWelcomeMessage = 'setPasswordWelcomeMessage',
		 Settings = 'settings',
		 ShowImages = 'showImages',
		 SignOut = 'signOut',
		 SmartFastAccurate = 'smartFastAccurate',
		 SomethingWentWrong = 'somethingWentWrong',
		 SomethingWentWrongWhileTryingToCreateNewAccount = 'somethingWentWrongWhileTryingToCreateNewAccount',
		 Sort = 'sort',
		 SortBy = 'sortBy',
		 SpecificDate = 'specificDate',
		 SpecificTime = 'specificTime',
		 State = 'state',
		 Status = 'status',
		 StopRecording = 'stopRecording',
		 Street = 'street',
		 Submit = 'submit',
		 Success = 'success',
		 Sync = 'sync',
		 t = 't',
		 TakeAPhoto = 'takeAPhoto',
		 TeamLeader = 'teamLeader',
		 TeamName = 'teamName',
		 TeamNotAssignedToBuilding = 'teamNotAssignedToBuilding',
		 TeamOverview = 'teamOverview',
		 ThereAreNoEntriesThatMatchSelectedCriteria = 'thereAreNoEntriesThatMatchSelectedCriteria',
		 ThisActionHasNoIssuesConnected = 'thisActionHasNoIssuesConnected',
		 ThisEmailIncludesALinkWhichLetsUser = 'thisEmailIncludesALinkWhichLetsUser',
		 ThisJobHasNoIssuesConnecteThisJobHasNoIssuesConnected = 'thisJobHasNoIssuesConnecteThisJobHasNoIssuesConnected',
		 ThisJobHasNoMediaYet = 'thisJobHasNoMediaYet',
		 ThisJobLogHasNoEntriesYet = 'thisJobLogHasNoEntriesYet',
		 ThisWeek = 'thisWeek',
		 Title = 'title',
		 To = 'to',
		 ToBeAssigned = 'toBeAssigned',
		 Today = 'today',
		 Tomorrow = 'tomorrow',
		 ToSync = 'toSync',
		 Type = 'type',
		 TypeOfJob = 'typeOfJob',
		 TypeReasons = 'typeReasons',
		 Unaccepted = 'unaccepted',
		 Unassigned = 'unassigned',
		 UnassignJob = 'unassignJob',
		 UnitArea = 'unitArea',
		 UnsupportedPhotoExtensionMessage = 'unsupportedPhotoExtensionMessage',
		 UpdateAvailable = 'updateAvailable',
		 UpdateAvailableMessage = 'updateAvailableMessage',
		 UpdateJobDetailsErrorMessage = 'updateJobDetailsErrorMessage',
		 UploadFile = 'uploadFile',
		 UploadPhotoErrorMessage = 'uploadPhotoErrorMessage',
		 UpsItLooksLikeThisSectionHasNoInformationAvailable = 'upsItLooksLikeThisSectionHasNoInformationAvailable',
		 Urgency = 'urgency',
		 Urgent = 'urgent',
		 UrgentOnly = 'urgentOnly',
		 UseCamera = 'useCamera',
		 Username = 'username',
		 VideoClipPreviewHeader = 'videoClipPreviewHeader',
		 VideoProcessingInfo = 'videoProcessingInfo',
		 ViewJobDetails = 'viewJobDetails',
		 WithAllJobsCompleted = 'withAllJobsCompleted',
		 Withdraw = 'withdraw',
		 WithoutAnyJobs = 'withoutAnyJobs',
		 WorkOrderReference = 'workOrderReference',
		 WrongEmailOrPassword = 'wrongEmailOrPassword',
		 Year = 'year',
		 Yes = 'yes',
		 YouCantDeactivateYourself = 'youCantDeactivateYourself',
		 YouDeclinedThisJob = 'youDeclinedThisJob',
		 YouFinishedThisJob = 'youFinishedThisJob',
		 YourAccountHasBeenSuccessfullyCreated = 'yourAccountHasBeenSuccessfullyCreated',
		 Zipcode = 'zipcode',
		 BuildingActionsHeaderStateTooltipAccepted = 'buildingActionsHeaderStateTooltipAccepted',
		 BuildingActionsHeaderStateTooltipExecuting = 'buildingActionsHeaderStateTooltipExecuting',
		 BuildingActionsHeaderStateTooltipFinished = 'buildingActionsHeaderStateTooltipFinished',
		 AutoSend = 'autoSend',
		 AutoSendExplanation = 'autoSendExplanation',
		 Directive = 'directive',
		 StatusTitleAccepted = 'statusTitleAccepted',
		 StatusTitleExecuting = 'statusTitleExecuting',
		 StatusTitleFinished = 'statusTitleFinished',
	}


